import { render } from "./SummarySection.vue?vue&type=template&id=f2a106f4&scoped=true"
import script from "./SummarySection.vue?vue&type=script&lang=js"
export * from "./SummarySection.vue?vue&type=script&lang=js"

import "./SummarySection.vue?vue&type=style&index=0&id=f2a106f4&scoped=true&lang=css"

import exportComponent from "/var/www/matchmaker/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f2a106f4"]])

export default __exports__